/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  GetPropertyHubFloorResponse
} from '../model';

import getPropertyHubFloorMutator from '../../../mutators/datastore-instance';



  /**
 * property-hub（ゲンコネ）のフロア図面（floor_plan）を、呼び出し元の bearer トークンで中継して取得する。
 * propertyId / floorId は property-hub 側のID（= genkone_id）。
 * 上流が 404 の場合は 404、5xx / 接続失敗の場合は 502 を返す。
 * @summary property-hub フロア図面取得
 */
export const getPropertyHubFloor = (
    propertyId: number,
    floorId: number,
 ) => {
      return getPropertyHubFloorMutator<GetPropertyHubFloorResponse>(
      {url: `/proxy/property-hub/properties/${propertyId}/floors/${floorId}`, method: 'GET'
    },
      );
    }
  export type GetPropertyHubFloorResult = NonNullable<Awaited<ReturnType<typeof getPropertyHubFloor>>>
